var React = require('react');

function Circle5pxHalflineVerticalInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Netzplanstation 2_28px"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-82.000000, -56.000000)","stroke":"#000000","strokeWidth":"5"},React.createElement("g",{"transform":"translate(82.000000, 56.000000)"},[React.createElement("circle",{"fill":"#FFFFFF","cx":"14","cy":"14","r":"11.5","key":0}),React.createElement("line",{"x1":"14","y1":"3","x2":"14","y2":"13","strokeLinecap":"round","key":1})])))]);
}

Circle5pxHalflineVerticalInline.defaultProps = {"width":"28px","height":"28px","viewBox":"0 0 28 28","version":"1.1"};

module.exports = Circle5pxHalflineVerticalInline;

Circle5pxHalflineVerticalInline.default = Circle5pxHalflineVerticalInline;
